import { render } from "./PublicWelfare.vue?vue&type=template&id=30a09727&ts=true"
import script from "./PublicWelfare.vue?vue&type=script&lang=ts"
export * from "./PublicWelfare.vue?vue&type=script&lang=ts"

import "./PublicWelfare.vue?vue&type=style&index=0&id=30a09727&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__